package com.milta.feature.route.domain.entity

/**
 * MIL-99 — an Enterprise's saved loading address (where its drivers pick up the goods), sent as
 * `loadingAddressId` when creating a route/batch so RoutaR starts the optimization from there.
 * [latitude]/[longitude] always come from the HERE suggestion picked when it was added.
 */
data class LoadingAddress(
    val id: String,
    val address: String,
    val latitude: Double,
    val longitude: Double,
    val lastUsedAt: String?,
) {
    /** Display title — the part before the first comma (street + number). */
    val title: String get() = address.substringBefore(',').trim()

    /** Display subtitle — everything after the first comma, empty when there is none. */
    val subtitle: String get() = address.substringAfter(',', missingDelimiterValue = "").trim()
}
